import { render, staticRenderFns } from "./PendingCustomer.vue?vue&type=template&id=d28368b8&scoped=true&"
import script from "./PendingCustomer.vue?vue&type=script&lang=js&"
export * from "./PendingCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PendingCustomer.vue?vue&type=style&index=0&id=d28368b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28368b8",
  null
  
)

export default component.exports